import type {
	ModuleFull,
	SetAsideResponse,
} from "@features/modules/setAside/types";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

const includedPropList = [
	"id",
	"status",
	"area",
	"ha_start",
	"ha_w",
	"ha_wo",
	"land_use_type_start",
	"land_use_type_w",
	"land_use_type_wo",
	"land_use_type_thread",
	"ha_thread",
	"note",
	"land_use_change",
];
const includedT2PropList = [
	"biomass_t2_start",
	"biomass_t2_w",
	"biomass_t2_wo",
	"soc_t2_start",
	"soc_t2_w",
	"soc_t2_wo",
	"flu_t2_start",
	"flu_t2_w",
	"flu_t2_wo",
	"fmg_t2_start",
	"fmg_t2_w",
	"fmg_t2_wo",
	"fi_t2_start",
	"fi_t2_w",
	"fi_t2_wo",
];

// Define constants for the module
const MODULE_TYPE = "SetAside";
const TAG: TagTypes = "SetAside";
const TAG_DEFAULTS: TagTypes = "SetAsideDefaults";
const ENDPOINT = FEModulesObj[FEModules.SetAside].path;

const transformResponse = (response: SetAsideResponse) => transformModuleResponse<SetAsideResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList
})

const setAsideApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicSetAsideApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: Partial<ModuleFull>, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, SetAsideResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
	includesLandUseChange: true
})

export const {
	useGetSetAsideQuery,
	useGetSetAsideDefaultsQuery
} = setAsideApiSlice;

export const {
	useGetSetAsideQuery: usePublicGetSetAsideQuery,
	useGetSetAsideDefaultsQuery: usePublicGetSetAsideDefaultsQuery
} = publicSetAsideApiSlice;

export const {
	useUpdateSetAsideMutation,
} = mutationApiSlice;

export const setAsideEndpoints = setAsideApiSlice.endpoints;
export const setAsideMutationEndpoints = mutationApiSlice.endpoints;
